<script setup lang="ts">
import { type UserProviderType, EProviders } from '@rfc/rfc-components-library/types'
import { provide } from 'vue'

provide<UserProviderType>(EProviders.USER, {})
</script>

<template>
    <slot />
</template>
